document.addEventListener('DOMContentLoaded', function () {
  const mobileMedia = window.matchMedia('(max-width: 767px)');
  const footer = document.querySelector('footer');
  const checkoutButton = document.querySelector('#checkoutButton');
  const total = document.querySelector('#total');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!mobileMedia.matches) {
          return;
        }
        if (entry.isIntersecting) {
          checkoutButton.style.transform = 'translateY(200%)';
          total.style.transform = 'translateY(200%)';
        } else {
          checkoutButton.style.transform = 'translateY(0)';
          total.style.transform = 'translateY(0)';
        }
      });
    },
    {
      rootMargin: '0px 0px -70px 0px',
    },
  );

  observer.observe(footer);
});
